module.exports = __webpack_public_path__ + "img/u_search-primary.377775e0.svg";